import {createAction, props} from '@ngrx/store';
import {Info} from '../../services/info/types/info';

export enum InfoActionTypes {
  AKTUALIZUJ_INFO = '[INFO] aktualizuj',
}

export const aktualizujInfo = createAction(
  InfoActionTypes.AKTUALIZUJ_INFO,
  props<Info>()
);
